module.exports = __webpack_public_path__ + "static/media/editable-pencil-dark.05d7750d.svg";